<!-- header.component.html -->
<div fxLayout="column" class="header-wrapper" >

  <!-- Top Bar -->
  <div fxLayout="row" fxLayoutAlign="space-between center" class="top-bar">
    <div fxLayout="row" fxLayoutGap="10px" class="top-links">
      <a href="#">About Us</a> |
      <a href="#">My Account</a> |
      <a href="#">Wishlist</a> |
      <a href="#">Order Tracking</a>
    </div>
    <div class="delivery-text">100% Secure delivery without contacting the courier</div>
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" class="lang-currency">
      <span>Need help? Call Us:+ 1800 900</span> |
      <span>English ▼</span> |
      <span><img src="https://flagcdn.com/us.svg" width="20"> USD ▼</span>
    </div>
  </div>

  <mat-toolbar>

        <mat-toolbar-row class="theme-container" style="height: 100%; background-color: white;" fxLayoutAlign="space-around center">



            <section fxFlex="25">
                <div *ngIf="data.disableSearchInHeader==0" class="search-bar" fxHide fxShow.gt-sm fxShow.gt-sm fxLayout="row" fxLayoutAlign="start center"
                    fxFlex fxFlex.gt-sm="300px">
                    <calsoft-search [scroll]="false"></calsoft-search>
                </div>
            </section>


            <section>
                <calsoft-logo [sitename]="data.siteName" [type]="'light'"></calsoft-logo>

            </section>

            <section>

            </section>
            <section fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">
                <!-- <calsoft-call [data]="data"></calsoft-call> -->
                <div *ngIf="languageSelection==1">
                    <calsoft-language style="color: black"></calsoft-language>
                </div>

                <div *ngIf="data.disableLoginHeader==0">
                <button *ngIf="!userLoggedIn" (click)="SignIn('login')" style="line-height: 15px" mat-button>
                    <div style="color: black" fxLayout="column">
                        <mat-icon>person</mat-icon>
                    </div>
                </button>
                </div>
                <div *ngIf="data.disableLoginHeader==0">
                <calsoft-HeaderUserProfileDropdown [data]="data"  class="headerUser" *ngIf="userLoggedIn">
                </calsoft-HeaderUserProfileDropdown>
                </div>

                <calsoft-cart-icon [data]="data"   ></calsoft-cart-icon>
            </section>

        </mat-toolbar-row>

    </mat-toolbar>
</div>
